export class TypeConges
{
    id: string|undefined;
    libelle: string;
}